module.exports = __webpack_public_path__ + "static/media/barcode-white.0626f2c2.svg";